import { useEffect, useState } from "react";
import { Paper } from "@mui/material";

import { UserRoleDialog } from "./user-role.dialog";
import { useLoadData } from "../../hooks/useLoadData";
import { ApiResponse } from "../../models/api-response";
import { useAuthorize } from "../../hooks/use-authorize";
import { SiTrackPage } from "../../components/si-track-page";
import { PlanReviewTabs } from "./plan-review-tabs.component";
import { UserPermissionName } from "../../models/user-permission-name";
import { planReviewApiKeyStore } from "../../api/plan-review-api-key-store";

export const PlanReviewDashboardPage = () => {

    const [roleData, setRoleData] = useState<any>();
    const [roleDialog, setRoleDialog] = useState<boolean>(false);

    const handleUserRole = (userRole: any) => {
        setRoleData(userRole);
        setRoleDialog(false);
    }

    const { data: dashboardRoleData, isLoading: isDashboardRoleLoading, isError } = useLoadData<ApiResponse<any>>(planReviewApiKeyStore.getPlanReviewDashboardRole());

    useEffect(() => {
        if (dashboardRoleData) {
            
            setRoleData(dashboardRoleData?.data)
            setRoleDialog(!dashboardRoleData?.data?.roleID);
        }
        if (isError) setRoleDialog(true)
    }, [dashboardRoleData, isError])

    const permissionForTab = {
        eneryModelingTab: useAuthorize([UserPermissionName.VIEW_ENERGY_MODELING_DASHBOARD]),
        hvacDesignTab: useAuthorize([UserPermissionName.VIEW_HVAC_DESIGN_ANALYSIS_DASHBOARD]),
        fileProcessingTab: useAuthorize([UserPermissionName.VIEW_FILE_PROCESSING_DASHBOARD]),
        reportProcessingTab: useAuthorize([UserPermissionName.VIEW_REPORT_DASHBOARD]),
        rebateProcessingTab: useAuthorize([UserPermissionName?.VIEW_REBATE_DASHBOARD]),
        privateProviderTab: useAuthorize([UserPermissionName.VIEW_PRIVATE_PROVIDER_PLAN_REVIEW_DASHBOARD]),
    };

    return (
        <SiTrackPage title="Plan Review Dashboard">
            <Paper elevation={0} sx={{ mt: 2 }}>
                {!permissionForTab?.eneryModelingTab &&
                    !permissionForTab?.hvacDesignTab &&
                    !permissionForTab?.fileProcessingTab &&
                    !permissionForTab?.reportProcessingTab &&
                    !permissionForTab?.rebateProcessingTab &&
                    !permissionForTab?.privateProviderTab ? null : (
                    <PlanReviewTabs
                        permissionForTab={permissionForTab}
                        userRole={roleData}
                        isRoleLoading={isDashboardRoleLoading}
                        handleUserRole={() => setRoleDialog(true)} />
                )}
            </Paper>
            {roleDialog && (
                <UserRoleDialog
                    roleID={roleData?.roleID}
                    onSubmit={handleUserRole}
                    onClosed={() => setRoleDialog(false)} />
            )}
        </SiTrackPage>
    );
}